;(function ($) {

  var cardsList = $('#blog_masonry');

  $(document).ready(function () {

    $('body').on('change', '#select_blog_category', blog_filter_change);

  });



  /**
   * Reload the Page when someone selects a category from the dropdown
   */
  function blog_filter_change() {
    var $this = $(this),
      url = $this.val();

    if (url.length) {
      window.location = url;
    }
  }

})(jQuery);
